import RandomIdObject from "../../../../src/mdx/api/schema/randomId-object.mdx";
import * as React from 'react';
export default {
  RandomIdObject,
  React
};